module.exports = __webpack_public_path__ + "static/media/Centra-IoT_Landscape_HQ.155a1aa1.png";